import logger from '../services/logger';

// Track page views and navigation
let lastPageUrl = window.location.pathname;
let pageStartTime = Date.now();

export function initializeEventTracking() {
  // 1. Track Click Events
  document.addEventListener('click', (e) => {
    try {
      const target = e.target;
      const elementId = target.id || (target && target.closest('[id]') && target.closest('[id]').id) || '';
      const elementClass = target.className || '';
      const pageUrl = window.location.pathname;
      
      logger.logClick(
        elementId,
        typeof elementClass === 'string' ? elementClass : '',
        pageUrl,
        e.clientX,
        e.clientY
      );
    } catch (error) {
      console.error('Error tracking click:', error);
    }
  }, true);

  // 2. Track Global Errors
  window.addEventListener('error', (e) => {
    try {
      logger.logError(
        e.message,
        (e.error && e.error.stack) || '',
        e.filename,
        e.lineno,
        e.colno
      );
    } catch (error) {
      console.error('Error tracking error:', error);
    }
  });

  // 3. Track Unhandled Promise Rejections
  window.addEventListener('unhandledrejection', (e) => {
    try {
      logger.logError(
        'Unhandled Promise Rejection: ' + e.reason,
        (e.reason && e.reason.stack) || '',
        window.location.pathname,
        0,
        0
      );
    } catch (error) {
      console.error('Error tracking promise rejection:', error);
    }
  });

  // 4. Track Navigation Changes (for SPA)
  window.addEventListener('popstate', () => {
    try {
      const currentUrl = window.location.pathname;
      const duration = Date.now() - pageStartTime;
      
      logger.logPageView(
        lastPageUrl,
        currentUrl,
        duration,
        document.referrer
      );
      
      lastPageUrl = currentUrl;
      pageStartTime = Date.now();
    } catch (error) {
      console.error('Error tracking navigation:', error);
    }
  });

  // 5. Track initial page load
  try {
    logger.logPageView(
      document.referrer,
      window.location.pathname,
      0,
      document.referrer
    );
  } catch (error) {
    console.error('Error tracking initial page load:', error);
  }

  console.log('Event tracking initialized');
}

// Helper function to track route changes in React Router
export function trackRouteChange(fromPath, toPath) {
  try {
    const duration = Date.now() - pageStartTime;
    
    logger.logPageView(
      fromPath,
      toPath,
      duration,
      document.referrer
    );
    
    lastPageUrl = toPath;
    pageStartTime = Date.now();
  } catch (error) {
    console.error('Error tracking route change:', error);
  }
}

// Helper function to track form submissions
export function trackFormSubmit(formId, formName, fieldCount) {
  try {
    logger.logFormSubmit(
      formId,
      formName,
      window.location.pathname,
      fieldCount
    );
  } catch (error) {
    console.error('Error tracking form submit:', error);
  }
}

// Export logger for direct use
export { logger };
